import React from "react";
import { Home, Settings, Payment, ExitToApp } from "@mui/icons-material";
import SideMenu from "../../../components/SideMenu/SideMenu";

const MenuLateral = ({ setCurrentView, handleClose }) => {
  const menuItems = [
    { text: "Início", icon: <Home />, view: "inicio" },
    { text: "Configurações", icon: <Settings />, view: "configuracoes" },
    { text: "Assinatura", icon: <Payment />, view: "pagamento" },
    {
      text: "Sair",
      icon: <ExitToApp />,
      action: () => {
        localStorage.removeItem("token");
        window.location.href = "/login";
      },
    },
  ];

  return (
    <SideMenu
      setCurrentView={setCurrentView}
      handleClose={handleClose}
      menuItems={menuItems}
      title="Future Trade"
      subtitle="Painel do Usuário"
      description="Acesso aos indicadores"
      defaultActiveView="inicio"
    />
  );
};

export default MenuLateral;
